// extracted by mini-css-extract-plugin
module.exports = {"tabList":"tabList__dJVjZ"};